/**
 * The home screen's shelves of pages (owner, 2026-10-15), by family root id (`familyRootOf`): the
 * pages ready to hand a child, big and in this order; the letter pages as "School"; every other
 * open family under "Under construction", newest first.
 */
export const READY_SHELF: readonly string[] = [
  'finger-painting',
  'splat',
  'ooze',
  'moon-slime',
  'slime-family',
  'candy',
  'drip-wall',
  'frames',
]

export const SCHOOL_SHELF: readonly string[] = [
  'ghost-letters',
  'groove-letters',
  'sand-letters',
  'right-way',
  'letter-blocks',
  'spell-it',
  'reading-shelf',
]

export type Shelf = 'ready' | 'school' | 'construction'

export function shelfOf(rootId: string): Shelf {
  if (READY_SHELF.includes(rootId)) return 'ready'
  if (SCHOOL_SHELF.includes(rootId)) return 'school'
  return 'construction'
}
